import {configureStore} from '@reduxjs/toolkit'

import userSlice from './user/userSlice'
import roleSlice from './role/roleSlice'
import passwordSlice from './password/passwordSlice'
import toolSlice from './tool/toolSlice'
import campusSlice from './campus/campusSlice'
import generalSlice from './general/generalSlice'
import academicSlice from './academic/academicSlice'
import lecturerSlice from './lecturer/lecturerSlice'
import regulationSlice from './regulation/regulationSlice'
import financeSlice from './finance/financeSlice'
import studentSlice from './student/studentSlice'
import adminSlice from './admin/adminSlice'
import formSlice from './form/formSlice'
import chatSlice from './chat/chatSlice'
import reportSlice from './report/reportSlice'

export const store = configureStore({
  reducer: {
    user: userSlice,
    role: roleSlice,
    passwordSlice: passwordSlice,
    tools: toolSlice,
    campus: campusSlice,
    general: generalSlice,
    academic: academicSlice,
    lecturer: lecturerSlice,
    regulation: regulationSlice,
    finance: financeSlice,
    student: studentSlice,
    admin: adminSlice,
    form: formSlice,
    chat: chatSlice,
    report: reportSlice,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
